export default "__VITE_ASSET__B1_RJSJU__"